/*
 * ANANDA Cart Gate — order-minimum (4 units) + 18+/terms confirmation, plus
 * two-way sync between the cart DRAWER and the /cart PAGE.
 * Loaded ONCE, globally, via ananda-fx.liquid (NOT inside the cart snippet,
 * which Dawn re-renders via innerHTML so inline scripts never run).
 *
 * Source of truth: this script. On every cart change (PUB_SUB cartUpdate) it
 * reads the real item_count from /cart.js and updates BOTH surfaces identically:
 *   - the red "add N more" nudge (incl. the live N)
 *   - the "מינימום 4 יח' במשלוח" banner line
 *   - the checkout button (disabled + data-ananda-min-met flag)
 *   - the accelerated-checkout buttons (.ananda-age-locked)
 *   - the 4 discount-progress meters (snippets/ananda-cart-meter.liquid)
 * The two gates are INDEPENDENT: checkout is enabled only when the 18+/terms box
 * is ticked AND the cart holds >= 4 units (either one failing blocks).
 *
 * Why JS and not just Liquid: on the /cart page Dawn only re-renders the
 * `.js-contents` region on a quantity change, and our gate markup lives OUTSIDE
 * it. And Dawn refreshes only the surface that originated a change (a qty/remove
 * on the page leaves the header drawer stale, and vice-versa) — both use the
 * same cartUpdate `source:'cart-items'`, so the event can't tell them apart.
 * We track which surface the shopper last edited (capture-phase listener, before
 * Dawn's own handlers) and refresh the OTHER one, in both directions.
 *
 * The checkbox markup + all related CSS live in snippets/ananda-cart-age.liquid;
 * the gate markup lives in cart-drawer.liquid / main-cart-footer.liquid. Server
 * render produces the correct first paint (no-JS fallback); this keeps it live.
 */
(function () {
  if (window.__anandaCartAgeInit) return;
  window.__anandaCartAgeInit = true;

  var MIN_UNITS = 4;
  var lastCount = null;
  var lastSurface = null; // 'page' | 'drawer' — which surface the shopper last edited

  function qsa(sel) { return Array.prototype.slice.call(document.querySelectorAll(sel)); }
  function cartUrl() { return (window.routes && routes.cart_url) ? routes.cart_url : '/cart'; }

  function anyChecked() {
    return qsa('[data-ananda-cart-age-cb]').some(function (cb) { return cb.checked; });
  }

  // Apply the full gate state for a known unit count, across BOTH surfaces.
  function gate(count) {
    if (typeof count !== 'number') return;
    lastCount = count;
    renderMeters(count);
    var confirmed = anyChecked();
    var minMet = count >= MIN_UNITS;
    var empty = count <= 0;

    qsa('[data-ananda-banner-min]').forEach(function (el) {
      el.hidden = minMet || empty;
    });

    qsa('[data-ananda-min-msg]').forEach(function (el) {
      el.hidden = minMet || empty;
      var n = el.querySelector('[data-ananda-min-remaining]');
      if (n) n.textContent = Math.max(0, MIN_UNITS - count);
    });

    qsa('button[name="checkout"]').forEach(function (b) {
      b.setAttribute('data-ananda-min-met', minMet ? 'true' : 'false');
      b.disabled = empty || !(confirmed && minMet);
    });

    qsa('.cart__dynamic-checkout-buttons, .additional-checkout-buttons').forEach(function (c) {
      c.classList.toggle('ananda-age-locked', !(confirmed && minMet));
    });
  }

  // Monotonic token: rapid edits fire parallel /cart.js fetches and HTTP does
  // not guarantee arrival order — a stale count landing LAST used to win and
  // freeze the gate + meters wrong (e.g. checkout left disabled at 4 units).
  // Only the newest request's response may drive the gate.
  var fetchSeq = 0;
  function fetchCount(cb) {
    var id = ++fetchSeq;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { if (id === fetchSeq) cb(c.item_count); })
      .catch(function () {});
  }

  // Re-render the cart DRAWER (used when the change happened on the /cart page).
  // Dawn's own onCartUpdate fetches ?section_id=cart-drawer and swaps the items +
  // .cart-drawer__footer; then re-apply the gate to the parts it doesn't touch.
  function refreshDrawerSurface() {
    var di = document.querySelector('cart-drawer-items');
    if (!di || typeof di.onCartUpdate !== 'function') return;
    var p = di.onCartUpdate();
    if (p && typeof p.then === 'function') p.then(function () { gate(lastCount); });
  }

  // Re-render the /cart PAGE (used when the change happened in the drawer). Dawn's
  // drawer update only renders cart-drawer + the icon bubble, leaving the page's
  // line items (incl. the quantity <input>) and the subtotal stale. cart-items'
  // own onCartUpdate refreshes the items section; the footer subtotal is a
  // separate section (main-cart-footer), so fetch + swap its .js-contents too.
  // gate() handles the banner / nudge / checkout button (outside .js-contents).
  function refreshPageSurface() {
    var ci = document.querySelector('cart-items');
    if (!ci) return;
    if (typeof ci.onCartUpdate === 'function') {
      var p = ci.onCartUpdate();
      if (p && typeof p.then === 'function') p.then(function () { gate(lastCount); });
    }
    fetch(cartUrl() + '?section_id=main-cart-footer')
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var src = doc.querySelector('#main-cart-footer .js-contents');
        var tgt = document.querySelector('#main-cart-footer .js-contents');
        if (src && tgt) tgt.innerHTML = src.innerHTML;
        gate(lastCount);
      })
      .catch(function () {});
  }

  function persist(confirmed) {
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'אישור גיל 18+': confirmed ? 'כן' : '' } })
      });
    } catch (e) {}
  }

  // Note which cart surface the shopper is editing, so after the change we can
  // refresh the OTHER one. Capture phase → runs before Dawn's own handlers.
  // 'change' covers the qty input + the +/- buttons (they dispatch change on the
  // input); 'click' covers the remove button (it calls updateQuantity directly,
  // with no change event).
  function noteSurface(e) {
    var el = e.target;
    if (!el || !el.closest) return;
    if (el.closest('cart-drawer-items')) lastSurface = 'drawer';
    else if (el.closest('cart-items')) lastSurface = 'page';
  }
  document.addEventListener('change', noteSurface, true);
  document.addEventListener('click', noteSurface, true);

  // Ticking/unticking the confirmation: mirror across surfaces, re-gate, persist.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-ananda-cart-age-cb]')) return;
    var confirmed = t.checked;
    qsa('[data-ananda-cart-age-cb]').forEach(function (cb) { cb.checked = confirmed; });
    if (lastCount === null) fetchCount(gate);
    else gate(lastCount);
    persist(confirmed);
  });

  // Any cart mutation. For source !== 'cart-items' (e.g. an add from a product
  // form) Dawn already cross-refreshes every surface, so we only re-gate. For
  // source === 'cart-items' (a qty/remove on the page OR in the drawer) Dawn
  // refreshed ONLY the originating surface — so we refresh the other one.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      // Drive the meter SYNCHRONOUSLY when the event carries the new count — a
      // +/- quantity change ships the full cart as event.cartData (source
      // 'cart-items', confirmed in Dawn's cart.js). gate() → renderMeters then
      // snaps to the OLD fill and animates to the NEW one in the SAME task as
      // Dawn's re-render, before any paint: the first painted frame is the old
      // fill and the bar sweeps ONCE, smoothly, to the new value. Deferring this
      // to the async /cart.js fetch below instead let the browser paint Dawn's
      // fresh new fill first and THEN jump back to animate — the "fill → empty a
      // little → fill" stutter Roi flagged (2026-07-14). The fetch stays as the
      // authoritative backstop (and covers adds, whose event carries no count).
      if (event && event.cartData && typeof event.cartData.item_count === 'number') {
        gate(event.cartData.item_count);
      }
      var fromCartSurface = !!(event && event.source === 'cart-items');
      var surface = lastSurface;
      lastSurface = null;
      fetchCount(function (count) {
        gate(count);
        if (!fromCartSurface) return;
        if (surface === 'drawer') refreshPageSurface();
        else if (surface === 'page') refreshDrawerSurface();
        else { refreshPageSurface(); refreshDrawerSurface(); } // origin unknown — sync both
      });
    });
  }

  // ---------- Confetti burst on the "משלוח חינם" banner line ----------
  // Ported from the ANANDA Floating Words section (confetti effect only, no bob):
  // a 4-brand-colour underline draws under the line then explodes into thin
  // streamer confetti. Fires on click of the line + auto when it first appears.
  var CC_COLORS = [
    'color-mix(in srgb, #E37A2C 68%, white)', // ALOHA
    'color-mix(in srgb, #1F6E4F 68%, white)', // GAIA
    'color-mix(in srgb, #B33640 68%, white)', // KYOTO
    'color-mix(in srgb, #1E5A99 68%, white)'  // SANTORINI
  ];
  function ccRemove() { if (this.parentNode) this.parentNode.removeChild(this); }
  function confettiBurst(host) {
    if (!host || host.querySelector('.ananda-cc-underline')) return; // one burst at a time
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var line = document.createElement('span');
    line.className = 'ananda-cc-underline';
    line.addEventListener('animationend', ccRemove);
    host.appendChild(line);
    var N = 28;
    for (var k = 0; k < N; k++) {
      var s = document.createElement('span');
      s.className = 'ananda-cc-piece';
      var oxFrac = (k + 0.5) / N + (Math.random() - 0.5) / N; // spread across the line width
      var ox = oxFrac * 100;
      var dir = (oxFrac - 0.5) * 2;                            // -1..+1 → fan outward
      var px = dir * (16 + Math.random() * 34) + (Math.random() * 16 - 8);
      var py = -(30 + Math.random() * 34);                     // up a bit
      var dx = px * 1.5 + (Math.random() * 20 - 10);
      var dy = py + 64 + Math.random() * 60;                   // gravity → fall & fade
      var w = 2.5 + Math.random() * 1.5;
      var h = 10 + Math.random() * 7;
      var r0 = 70 + Math.random() * 40;
      var r1 = r0 + (Math.random() * 2 - 1) * 150;
      var r2 = r1 + (Math.random() * 2 - 1) * 260;
      var dur = 0.95 + Math.random() * 0.6;
      var delay = 0.30 + Math.random() * 0.12;                 // launch as the line explodes
      s.style.cssText =
        '--ox:' + ox.toFixed(1) + '%;--c:' + CC_COLORS[k % 4] + ';' +
        '--w:' + w.toFixed(1) + 'px;--h:' + h.toFixed(1) + 'px;' +
        '--px:' + px.toFixed(1) + 'px;--py:' + py.toFixed(1) + 'px;' +
        '--dx:' + dx.toFixed(1) + 'px;--dy:' + dy.toFixed(1) + 'px;' +
        '--r0:' + r0.toFixed(0) + 'deg;--r1:' + r1.toFixed(0) + 'deg;--r2:' + r2.toFixed(0) + 'deg;' +
        '--dur:' + dur.toFixed(2) + 's;--delay:' + delay.toFixed(2) + 's;';
      s.addEventListener('animationend', ccRemove);
      host.appendChild(s);
    }
  }

  function setupConfetti() {
    // Click the line to (re)play.
    document.addEventListener('click', function (e) {
      var host = e.target && e.target.closest && e.target.closest('[data-ananda-confetti]');
      if (host) confettiBurst(host);
    });
    // Auto-burst when the drawer transitions into the open (.active) state.
    var drawerEl = document.querySelector('cart-drawer');
    if (drawerEl && typeof MutationObserver === 'function') {
      var wasActive = drawerEl.classList.contains('active');
      new MutationObserver(function () {
        var active = drawerEl.classList.contains('active');
        if (active && !wasActive) {
          var line = drawerEl.querySelector('[data-ananda-confetti]');
          if (line) confettiBurst(line);
          sweepMeters(drawerEl); // entrance sweep for the drawer's meters
        }
        wasActive = active;
      }).observe(drawerEl, { attributes: true, attributeFilter: ['class'] });
    }
    // Auto-burst the /cart PAGE banner (visible immediately on load). The drawer's
    // own line is skipped here — it bursts on open via the observer above.
    qsa('[data-ananda-confetti]').forEach(function (l) {
      if (!l.closest('cart-drawer')) confettiBurst(l);
    });
  }

  // ---------- Discount-progress meter (snippets/ananda-cart-meter.liquid) ----------
  // A linear pricing clock: a sliding 4-unit window (4-8, 8-12, ... 20-24) whose
  // fill tracks the cart count. Tiers mirror the store's automatic discounts
  // (8->8% ... 24->24%), same table as the pricing clock. Rendered 4x (drawer
  // top/totals + /cart top/totals) — this engine drives ALL copies identically.
  //
  // Dawn re-renders cart markup via innerHTML, so a meter element may arrive
  // ALREADY at the new server state. Before animating we therefore SNAP every
  // meter back to the previous count's state (no transition), reflow, then
  // animate — the motion survives the re-render. Fresh elements swapped in
  // AFTER an animation (same count) are detected by the missing mSeen marker
  // and normalized instantly without cancelling a running animation.
  var METER_STEP = 4;
  var METER_CAP = 24;         // last discount tier — beyond it the meter shows "max"
  var METER_FILL_MS = 560;    // must track the CSS clip-path transition (0.55s)
  var METER_ROLL_MS = 300;    // must track the CSS odometer keyframes (0.3s)
  var meterCount = null;      // count the meters currently represent
  var meterSeq = 0;           // animation token — a newer pass cancels older async phases
  var meterReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function meterState(count) {
    var winMin = count >= 8 ? Math.floor(count / METER_STEP) * METER_STEP : MIN_UNITS;
    if (winMin > METER_CAP - METER_STEP) winMin = METER_CAP - METER_STEP;
    var winMax = winMin + METER_STEP;
    var fill = (count - winMin) / METER_STEP;
    if (fill < 0) fill = 0;
    if (fill > 1) fill = 1;
    return {
      count: count,   // the LEFT number shows the live cart count (Roi 2026-07-14),
                      // NOT winMin — winMin stays the fill's window floor below
      winMin: winMin,
      winMax: winMax,
      fill: fill,
      left: Math.max(0, winMax - count),
      maxed: count >= METER_CAP
    };
  }

  // Position the fill (LTR — revealed from the LEFT; 0.55s CSS transition unless
  // .is-snap). The knob was removed (Roi 2026-07-14): the smooth 4-colour fill
  // carries the progress on its own, like the pricing clock's arc.
  function meterFill(m, f) {
    var fill = m.querySelector('[data-ananda-meter-fill]');
    if (fill) fill.style.clipPath = 'inset(0 ' + (100 - f * 100) + '% 0 0)';
  }

  // Set a roll box's number. dir 0 = instant; +1/-1 = odometer roll up/down.
  // A change can land while a previous roll is still mid-flight (rapid +/-
  // taps), so first settle the box: drop every digit but the newest and strip
  // its animation classes — querySelector must never mistake an exiting digit
  // for the current one (that used to leave TWO static digits behind).
  function meterSetNum(m, sel, val, dir) {
    var box = m.querySelector(sel);
    if (!box) return;
    var digits = box.querySelectorAll('.ananda-cart-meter__digit');
    for (var i = 0; i < digits.length - 1; i++) {
      if (digits[i].parentNode) digits[i].parentNode.removeChild(digits[i]);
    }
    var cur = digits.length ? digits[digits.length - 1] : null;
    if (cur) cur.className = 'ananda-cart-meter__digit';
    var txt = String(val);
    if (cur && cur.textContent === txt) return;
    if (!dir || meterReduce || !cur) {
      if (cur) { cur.textContent = txt; return; }
      box.innerHTML = '<span class="ananda-cart-meter__digit">' + txt + '</span>';
      return;
    }
    cur.className = 'ananda-cart-meter__digit ' + (dir > 0 ? 'is-out-up' : 'is-out-down');
    var inn = document.createElement('span');
    inn.className = 'ananda-cart-meter__digit ' + (dir > 0 ? 'is-in-up' : 'is-in-down');
    inn.textContent = txt;
    box.appendChild(inn);
    setTimeout(function () {
      if (cur.parentNode) cur.parentNode.removeChild(cur);
      if (inn.parentNode) inn.className = 'ananda-cart-meter__digit';
    }, METER_ROLL_MS + 40);
  }

  // The sentence above the bar. Rebuilds (with a fade) when the mode flips
  // between "add X for the next tier" and "max discount reached"; otherwise
  // rolls just the two numbers. Keep the markup in lock-step with the snippet.
  function meterMsg(m, st, dir) {
    var msg = m.querySelector('[data-ananda-meter-msg]');
    if (!msg) return;
    var mode = st.maxed ? 'max' : 'add';
    if (msg.getAttribute('data-mode') !== mode) {
      msg.setAttribute('data-mode', mode);
      msg.innerHTML = st.maxed
        ? 'הגעתם להנחה המקסימלית - <span class="ananda-cart-meter__pct">24% הנחה</span>'
        : 'הוסיפו <span class="ananda-cart-meter__roll" data-ananda-meter-x><span class="ananda-cart-meter__digit">' + st.left + '</span></span> יח\' אננדה להנחה הבאה - <span class="ananda-cart-meter__pct"><span class="ananda-cart-meter__ltr"><span class="ananda-cart-meter__roll" data-ananda-meter-pct><span class="ananda-cart-meter__digit">' + st.winMax + '</span></span>%</span> הנחה</span>';
      if (!meterReduce) {
        msg.classList.remove('is-swap');
        void msg.offsetWidth;
        msg.classList.add('is-swap');
      }
      return;
    }
    if (!st.maxed) {
      meterSetNum(m, '[data-ananda-meter-x]', st.left, dir || 0);
      meterSetNum(m, '[data-ananda-meter-pct]', st.winMax, dir || 0);
    }
  }

  // Paint a full state instantly (no rolls, transitions still apply to fill).
  function meterApply(m, st) {
    m.dataset.mSeen = '1';
    meterFill(m, st.fill);
    meterSetNum(m, '[data-ananda-meter-min]', st.count, 0);   // left = live cart count
    meterSetNum(m, '[data-ananda-meter-max]', st.winMax, 0);
    meterMsg(m, st, 0);
  }

  function meterSnap(m, st) { // reposition with NO motion
    m.classList.add('is-snap');
    meterApply(m, st);
    void m.offsetWidth;
    m.classList.remove('is-snap');
  }

  // Tier-unlock celebration: ring pulse on the track + confetti on the message
  // (confetti on visible meters only — the drawer copy may be closed).
  function meterCelebrate(m) {
    if (meterReduce) return;
    var track = m.querySelector('.ananda-cart-meter__track');
    if (track) {
      track.classList.add('is-pulse');
      setTimeout(function () { track.classList.remove('is-pulse'); }, 520);
    }
    var msg = m.querySelector('[data-ananda-meter-msg]');
    if (msg && m.offsetParent) confettiBurst(msg);
  }

  // Animate one meter from the previous count's state to the target.
  // The seq token is stamped ON THE ELEMENT: only a pass that repaints THIS
  // meter may cancel its pending phases. (A global-only token let a
  // drawer-scoped entrance sweep strand the /cart meters mid window-shift
  // with a stale scale + message — adversarial review 2026-07-14.)
  function meterAnimate(m, from, to, dir, seq) {
    m.__mSeq = seq;
    meterSnap(m, from); // fresh server markup may already sit at the target
    if (from.winMin === to.winMin) {
      meterFill(m, to.fill);
      meterSetNum(m, '[data-ananda-meter-min]', to.count, dir);  // left tracks the live cart count, every unit
      meterMsg(m, to, dir);
      if (dir > 0 && to.maxed && !from.maxed) {
        // The FINAL tier (24%) unlocks INSIDE the last window — same-window
        // path, but it deserves the celebration every other tier gets.
        setTimeout(function () {
          if (seq !== m.__mSeq) return;
          meterCelebrate(m);
        }, METER_FILL_MS + 40);
      }
      return;
    }
    if (dir > 0) {
      // FORWARD tier cross — the celebration Roi asked for (2026-07-14): the fill
      // runs UP to the window's full edge (tier reached → confetti + pulse), the
      // scale rolls to the next window, then the fill DRAINS smoothly back to the
      // empty edge ("the meter emptying and waiting for the next action") before
      // settling at the new window's actual level.
      meterFill(m, 1);                                  // 1) fill up to the crossed boundary
      setTimeout(function () {
        if (seq !== m.__mSeq) return;
        meterCelebrate(m);                              // 2) tier unlocked — confetti + ring pulse
        meterSetNum(m, '[data-ananda-meter-min]', to.count, dir);   // left = live count
        meterSetNum(m, '[data-ananda-meter-max]', to.winMax, dir);
        meterMsg(m, to, dir);
        meterFill(m, 0);                                // 3) SMOOTH drain to empty (no is-snap)
        setTimeout(function () {
          if (seq !== m.__mSeq) return;
          if (to.fill > 0) meterFill(m, to.fill);       // 4) settle at the new window's level (if any)
        }, METER_FILL_MS + 40);
      }, METER_FILL_MS + 40);
      return;
    }
    // BACKWARD (item removed → tier dropped): fill to the empty edge, roll the
    // scale down, then snap to the lower window's full edge and refill to target.
    meterFill(m, 0);
    setTimeout(function () {
      if (seq !== m.__mSeq) return;
      meterSetNum(m, '[data-ananda-meter-min]', to.count, dir);   // left = live count
      meterSetNum(m, '[data-ananda-meter-max]', to.winMax, dir);
      meterMsg(m, to, dir);
      m.classList.add('is-snap');
      meterFill(m, 1); // jump to the new (lower) window's full edge
      void m.offsetWidth;
      m.classList.remove('is-snap');
      setTimeout(function () {
        if (seq !== m.__mSeq) return;
        meterFill(m, to.fill);
      }, 60);
    }, METER_FILL_MS + 40);
  }

  // Drive every meter to `count`. Called from gate() on every cart change.
  function renderMeters(count) {
    var meters = qsa('[data-ananda-meter]');
    var prev = meterCount;
    meterCount = count;
    if (!meters.length) return;

    // The meter replaces the minimum-order messaging: below 4 units the red
    // nudge + banner line speak, so the meter stays hidden until the minimum.
    var st = meterState(count);
    var hide = count < MIN_UNITS;
    if (hide) {
      var hs = ++meterSeq;
      meters.forEach(function (m) { m.hidden = true; m.__mSeq = hs; });
      return;
    }
    meters.forEach(function (m) { m.hidden = false; });

    if (prev === count) {
      // Same count — only normalize meters Dawn just swapped in (no mSeen
      // marker). Never touch __mSeq here: a running animation must survive
      // the follow-up gate() calls made by the surface-refresh handlers.
      meters.forEach(function (m) { if (!m.dataset.mSeen) meterApply(m, st); });
      return;
    }
    if (prev === null || meterReduce) {
      var ss = ++meterSeq;
      meters.forEach(function (m) { m.__mSeq = ss; meterSnap(m, st); });
      return;
    }
    var seq = ++meterSeq;
    var from = meterState(prev);
    var dir = count > prev ? 1 : -1;
    meters.forEach(function (m) { meterAnimate(m, from, st, dir, seq); });
  }

  // Entrance sweep — the fill grows from the window edge to the current value
  // (like the clock's entrance). Fired when the drawer opens / the page loads.
  function sweepMeters(scopeEl) {
    if (meterReduce || meterCount === null || meterCount < MIN_UNITS) return;
    var st = meterState(meterCount);
    if (st.fill <= 0) return;
    var seq = ++meterSeq;
    qsa('[data-ananda-meter]').forEach(function (m) {
      if (scopeEl && !scopeEl.contains(m)) return;
      if (!scopeEl && m.closest('cart-drawer')) return; // page-only sweep
      m.__mSeq = seq; // cancel THIS meter's pending phases only — meters
                      // outside the scope keep animating undisturbed
      m.classList.add('is-snap');
      meterApply(m, st);   // labels + message at the real state...
      meterFill(m, 0);     // ...but the fill starts at the window edge
      void m.offsetWidth;
      m.classList.remove('is-snap');
      setTimeout(function () { if (seq === m.__mSeq) meterFill(m, st.fill); }, 200);
    });
  }

  function init() {
    // Only do work where a gate exists (the cart drawer is present on every page).
    if (!document.querySelector('[data-ananda-cart-age-cb], button[name="checkout"], [data-ananda-min-msg]')) {
      return;
    }
    // Mirror the saved confirmation onto every checkbox, then seed the gate from
    // the real count so the very first checkbox toggle has an accurate minimum.
    var confirmed = anyChecked();
    qsa('[data-ananda-cart-age-cb]').forEach(function (cb) { cb.checked = confirmed; });
    fetchCount(function (count) {
      gate(count);
      sweepMeters(null); // entrance sweep for the /cart page meters
    });
  }

  function boot() { init(); setupConfetti(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
}());
